import { Flex, Grid, Skeleton } from '@backstage/ui';
import { paginationOptions } from '../config';

const SUMMARY_CARD_COUNT = 4;
const TABLE_ROW_COUNT = paginationOptions.pageSize;

/**
 * Loading placeholder that mirrors the Insights page body (a row of summary
 * cards above a tracks table). Render it inside the page's existing
 * Header/Container so the title and owner picker stay visible.
 */
export const PulseInsightsSkeleton = () => (
  <Flex direction="column" gap="6">
    <Grid.Root columns={{ initial: '1', sm: '2', md: '4' }} gap="4">
      {Array.from({ length: SUMMARY_CARD_COUNT }, (_, index) => (
        <Grid.Item key={`card-${index}`}>
          <Skeleton width="100%" height={140} />
        </Grid.Item>
      ))}
    </Grid.Root>

    <Flex direction="column" gap="2">
      <Skeleton width="100%" height={44} />
      {Array.from({ length: TABLE_ROW_COUNT }, (_, index) => (
        <Skeleton
          key={`row-${index}`}
          width="100%"
          height="var(--bui-space-8)"
        />
      ))}
    </Flex>
  </Flex>
);
